import * as React from "react";
import { RouteComponentProps } from "react-router";
import { DatabaseRecordType } from "ui/Scripts/source/models/enums";
import { customHistory } from "../../framework/customHistory";
import { ICalendarTaskEditState as IStoreCalendarTaskEditState, IUserState } from "../../models/store/storeTypes";
import { CalendarTaskEditView } from "./calendarTaskEditView";
import { useEffect } from "react";

export interface ICalendarTaskEditOwnProps {
}

export interface ICalendarTaskEditStateProps {
    user: IUserState;
    calendarTaskEdit: IStoreCalendarTaskEditState;
}

export interface ICalendarTaskEditDispatchProps {
    loadCalendarTask: (taskId: string, databaseRecordType: DatabaseRecordType) => void;
    resetCalendarTask: () => void;
}

export interface ICalendarTaskEditPathProps {
    calendartaskId: string;
}

type CalendarTaskEditProp = ICalendarTaskEditOwnProps & ICalendarTaskEditStateProps & ICalendarTaskEditDispatchProps & RouteComponentProps<ICalendarTaskEditPathProps>;

export const CalendarTaskEdit = (props: CalendarTaskEditProp) => {
    useEffect(() => {
        const loadData = async () => {
            props.loadCalendarTask(props.match.params.calendartaskId, null);
        };

        loadData();
        return () => {
            props.resetCalendarTask();
        };
    }, []);

    const edit = props.calendarTaskEdit?.item;

    return (
        <CalendarTaskEditView
            inFullView={true}
            isReadOnly={false}
            user={props.user}
            canShareCalendarTasks={edit?.canShareCalendarTasks ?? false}
            canSaveCalendarTask={edit?.canSaveCalendarTask ?? false}
            canRemoveCalendarTask={edit?.canRemoveCalendarTask ?? false}
            userIsIsSystemAdmin={edit?.userIsIsSystemAdmin ?? false}
            calendarTaskId={props.match.params.calendartaskId}
            calendarTask={edit?.item}
            categories={edit?.categories}
            onClose={() => customHistory.push("/calendartask")}
        />
    );
};